import styled from 'styled-components';

const BreadcrumbWrapper = styled.div`
	ul {
		padding: 0;
		margin: 16px 0 0;

		@media (min-width: 1024px) {
			padding: 0 ${props => props.sidePadding || '0'};
			margin: 24px 0;
		}
	}
`;

export default BreadcrumbWrapper;
